export enum DealerSelectionMethod {
  SEARCH = "Search",
  FROM_MAP = "From map",
}

export enum VehicleSelectionMethod {
  REGNR = "Regnumber",
  MANUAL = "Manual",
}

export enum OrderConfirmationType {
  MAIL = "Mail",
}

export enum VehicleUpdateEventName {
  SELECT = "selected_model",
  CHANGE = "changed_model",
}

export enum DealerUpdateEventName {
  SELECT = "selected_dealer",
  CHANGE = "changed_dealer",
}
